import { render, staticRenderFns } from "./salinan_massal.vue?vue&type=template&id=0583761f&"
import script from "./salinan_massal.vue?vue&type=script&lang=js&"
export * from "./salinan_massal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports